import React, { useRef, useState, useEffect } from 'react';

import { Link } from "react-router-dom";
import _ from 'lodash';

import { styled } from '@mui/material/styles';

import Table from './table';
import { Paper, TextField, FormControl, Button } from '@mui/material';
import moment from 'moment';
import LessonsListFilters from '../activity-view/lessons_list_filters';

import FilterListIcon from '@mui/icons-material/FilterList';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import EditIcon from '@mui/icons-material/Edit';
import BouncingPreloader from '../common/bouncyLoader';

const PREFIX = 'Lessons';

const classes = {
    paper: `${PREFIX}-paper`,
    topbar: `${PREFIX}-topbar`,
    searchbar: `${PREFIX}-searchbar`,
    multicheckboxFilter: `${PREFIX}-multicheckboxFilter`,
    filter_button: `${PREFIX}-filter_button`,
    formControl: `${PREFIX}-formControl`,
    filterSummary: `${PREFIX}-filterSummary`,
    stage_options: `${PREFIX}-stage_options`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.paper}`]: {
        maxHeight:  Math.round(window.innerWidth * 0.9),
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
        width: 'calc(100vw - 40px)',
    },

    [`& .${classes.topbar}`]: {
        display: 'flex',
        padding: '1rem',
        paddingBottom: '0rem',
    },

    [`& .${classes.searchbar}`]: {
        display: 'inline-flex',
        alignItems: 'flex-end'
    },

    [`& .${classes.multicheckboxFilter}`]: {
      width: '200px',
      paddingBottom: '1rem',
      display: 'inline-block',
    },

    [`& .${classes.filter_button}`]: {
        backgroundColor: '#0B7CB0',
        color: 'white',
        minWidth: '20vw',
        height: '2.5rem',
        padding: '0.5rem',
        minWidth: '5vw',
    },

    [`& .${classes.formControl}`]: {
      minWidth: '17.5vw',
      maxWidth: 400
    },

    [`& .${classes.filterSummary}`]: {
      maxWidth: '60vw'  
      },

    [`& .${classes.stage_options}`]: {
      '&.MuiInputBase': {
        margin: '0px',
      },
      '&.MuiSelect-icon': {
        display: 'none',
      }
    }
}));

// Styles for the React Table
const Styles = styled('div')({
    padding: '1rem',
    paddingBottom: 0,
    '& .table': {
        display: 'flow-root',
        borderSpacing: 0,
        border: '1px solid black',
        borderLeft: 0,
        fontFamily: 'Roboto',
        overflowX: 'auto',
        '& .tr:last-child .td': {
            borderBottom: '1px solid black',
        },
        '& .th': {
            textAlign: 'left',
            background: '#093d61',
            color: 'white',
            height: '2.5rem',
            padding: '0.5rem',
            borderBottom: '1px solid black',
            borderRight: '1px solid black',
        },
        '& .td': {
            position: 'relative',
            margin: 0,
            padding: '0.4rem',
            paddingLeft: '0.5rem',
            paddingRight: '0.5rem',
            borderLeft: '1px solid black',
            borderBottom: '1px solid #d1d5da',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            '& .resizer': {
                display: 'inline-block',
                width: 7,
                height: '100%',
                position: 'absolute',
                right: 0,
                top: 0,
                transform: 'translateX(50%)',
                zIndex: 1,
                touchAction: 'none',
            },
        },
    },
});

//Function that pulls the data and sends it to the Table Renderer
const Lessons = props => {
    let { lessons_view_data, loading, ll_settings, updateLLViewSettings } = props;

    const tableInstance = useRef(null);
    var hiddenColumns = ['id'];
    let width = window.innerWidth-75;
 
    // Data being fed to the table
    const [lessonsViewData, setLessonsViewData] = useState(lessons_view_data) 

    const [showFilters, setShowFilters] = useState(false);
    const toggleShowFilters = (value=showFilters) => {
        setShowFilters(!value)
    }

    const [anchorEl, setAnchorEl] = React.useState(null);


    useEffect(() => {
        setLessonsViewData(lessons_view_data)
    },[lessons_view_data])

    const columns = React.useMemo(() => [
        {
            Header: 'Id',
            accessor: 'id',
            width: 5*width,
        },
        {
            Header: 'Lesson',
            accessor: 'title',
            width: 0.28*width,
            Cell: (props) => {
                if (localStorage.getItem('ll_admin')!=='true') {
                    return(props.value)    
                }
                let address = `/ll/new-lesson/${props.row.values.id}`

                return(
                    <div>
                        <Link
                            to={address}
                            target='_blank'
                            style={{textDecoration: 'none', color: 'black'}}
                        >
                            <div style={{display: 'flex'}}>{props.value}&nbsp;&nbsp;<EditIcon fontSize='small'/></div>
                        </Link>
                    </div>
                )
            },
        },
        {
            Header: 'Reviewed',
            accessor: 'reviewed',
            width: 0.07*width,
            Cell: (props) => {
                if (props.value) {
                    return(<CheckBoxIcon />)
                } else {
                    return(<CheckBoxOutlineBlankIcon />)
                }
            },
            // disableSortBy: true
            sortType: (rowA, rowB) => {
                if (rowA.original.reviewed) return 1; 
                return -1;
            },
        },
        {
            Header: 'Safety',
            accessor: 'safety',
            width: 0.07*width,
            Cell: (props) => {
                if (props.value) {
                    return(<CheckBoxIcon />)
                } else {
                    return(<CheckBoxOutlineBlankIcon />)
                }
            },
            // disableSortBy: true
            sortType: (rowA, rowB) => {
                if (rowA.original.safety) return 1; 
                return -1;
            },
        },
        {
            Header: 'Divsion',
            accessor: 'division',
            width: 0.1*width,
        },
        {
            Header: 'Author',
            accessor: 'author',
            width: 0.1*width,
            Cell: (props) => {
                let author = props.value ? props.value : '';
                author = author.includes('@arcomurray.com') ? author.split('@')[0] : author;

                return (<Root>{author}</Root>);
            }
        },
        {
            Header: 'Source',
            accessor: 'source',
            width: 0.08*width,
            Cell: (props) => {
                if (props.value) {
                    if (props.value.includes('arconnect')) {
                        return(<>ARCOnnect</>)
                    }    
                }
                return(<>{props.value}</>)
            }
        },
        {
            Header: 'Tagged Activities',
            accessor: 'selectedActivities',
            width: 0.1*width,
            Cell: (props) => {
                let value = (props.value==='...') ? '' : props.value;
                return (<>{value}</>)
            }
        },
        {
            Header: 'Date Created',
            accessor: 'date_created',
            width: 0.1*width,
            Cell: (props) => {
                return(
                    <>
                    {moment(props.value).format('MMM-DD-YYYY')}
                    </>
                )
            }
        },
        {
            Header: 'Date Updated',
            accessor: 'date_updated',
            width: 0.1*width,
            Cell: (props) => {
                return(
                    <>
                    {moment(props.value).format('MMM-DD-YYYY')}
                    </>
                )
            }
        },
    ]);

    return (
        <>
            {loading ? (
                <>
                <div style={{ position: 'absolute', top: '55%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <BouncingPreloader />
                </div>
                </>
            ) : (
                <Paper elevation={6} className={classes.paper} id='lessons_view'>
                    {/* Search bar */}
                    <div className={classes.topbar}>
                        <div className={classes.searchbar}>
                            <FormControl className={classes.formControl}>
                                <TextField 
                                    onChange={e => {
                                        tableInstance.current.setGlobalFilter(e.target.value);
                                    }}
                                    placeholder="Search..."
                                />
                            </FormControl>
                        </div> 
                        &emsp;
                        {/* Filter Button */}
                        <Button 
                            variant="contained"
                            className={classes.filter_button} 
                            onClick={(event) => {
                                toggleShowFilters()
                                setAnchorEl(event.currentTarget)
                            }}
                            size='small'
                        >
                            <FilterListIcon />
                            Filter
                        </Button>
                        {showFilters && (
                            <LessonsListFilters 
                                showFilters={showFilters}
                                toggleShowFilters={toggleShowFilters}
                                ll_settings={ll_settings} 
                                updateLLViewSettings={updateLLViewSettings}
                                anchorEl={anchorEl}                        
                            />
                        )}

                    </div>

                    <Styles>
                        <Table 
                            columns={columns} 
                            data={lessonsViewData} 
                            ref={tableInstance} 
                            hiddenColumns={hiddenColumns}
                            getCellProps={cellInfo => {

                                let columncheck = cellInfo.column.Header === "Tagged Activities" ? true : false;
                                let bgcolor = ''
                                if (columncheck) {
                                    bgcolor = cellInfo.row.values.selectedActivities ? ((cellInfo.row.values.selectedActivities !=='')&&(cellInfo.row.values.selectedActivities !=='...')) ? '#FFFFFF' : '#FFCCCB': '#FFCCCB';
                                    // fontcolor = '#FFFFFF'
                                }
                                return(
                                    {
                                        style: {
                                          backgroundColor: bgcolor,
                                        },
                                      }
                                )
                                return({})
                            }}                      
                        />
                    </Styles>
                </Paper>
            )}
        </>
    );
};

export default Lessons;